import { useEffect, useState } from 'react'

import { sectionAnchors } from '../../../config/routes'

type Step = {
  n: number
  title: string
  description: string
}

// Four ordered steps — numbered markers are justified because this is a
// real sequence, not a generic list. Ported verbatim from the prototype's .steps markup.
const STEPS: Step[] = [
  {
    n: 1,
    title: 'Set your answer key',
    description:
      'Type it in, or scan a master answer sheet. Multiple choice, true/false, identification, enumeration, fill-in-the-blanks, and open response.',
  },
  {
    n: 2,
    title: 'Scan each sheet',
    description:
      "Point your camera at each student's answer sheet. Good lighting, keep it flat, include the name area.",
  },
  {
    n: 3,
    title: 'AI reads & grades',
    description:
      "QuickScore reads the answers, grades them against the key, and pulls the student's name off the page.",
  },
  {
    n: 4,
    title: 'Review & export',
    description: 'Check anything it flagged, approve the results, then export to CSV or email them to yourself.',
  },
]

export const HowItWorksSection = () => {
  // matchMedia is browser-only; this site is SSR'd, so the check has to wait
  // for the client-side effect pass instead of running during render.
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false)

  useEffect(() => {
    const query = window.matchMedia('(prefers-reduced-motion: reduce)')
    setPrefersReducedMotion(query.matches)
    const onChange = () => setPrefersReducedMotion(query.matches)
    query.addEventListener('change', onChange)
    return () => query.removeEventListener('change', onChange)
  }, [])

  return (
    <section id={sectionAnchors.howItWorks.slice(1)} className="band">
      <div className="wrap">
        <div className="sec-head">
          <span className="eyebrow">How it works</span>
          <h2>From a stack of paper to scored results — in four steps</h2>
        </div>
        <div className="how-it-works-video">
          {prefersReducedMotion ? (
            <img src="/assets/img/quickscore-how-it-works-poster.jpg" alt="" aria-hidden="true" />
          ) : (
            <video
              muted
              loop
              playsInline
              autoPlay
              preload="metadata"
              poster="/assets/img/quickscore-how-it-works-poster.jpg"
              aria-hidden="true"
            >
              <source src="/assets/video/quickscore-how-it-works.webm" type="video/webm" />
              <source src="/assets/video/quickscore-how-it-works.mp4" type="video/mp4" />
            </video>
          )}
        </div>
        <div className="steps">
          {STEPS.map((step) => (
            <div className="step" key={step.n}>
              <div className="n">{step.n}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
